import { render, staticRenderFns } from "./LayerSelector.vue?vue&type=template&id=472494b2&scoped=true"
import script from "./LayerSelector.vue?vue&type=script&lang=js"
export * from "./LayerSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472494b2",
  null
  
)

export default component.exports